import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get Task 
export const getTasks = createAsyncThunk("get-task-list", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.get(`${baseUrl}cleaningappfunctions/operations/app/v1/get-task-list/22106000002595040`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        // console.log({'resppppppppppppppredux' :response })
        return response;
    } catch (error) {
        console.error('Error fetching Sites - ', error);
        throw error;
    }
})